export const version = 'v1.25.0';
export const channel = 'rpp-it-customer-care-web-app';
